import { render, staticRenderFns } from "./userTabs.vue?vue&type=template&id=b4943ac4&"
import script from "./userTabs.vue?vue&type=script&lang=js&"
export * from "./userTabs.vue?vue&type=script&lang=js&"
import style0 from "./userTabs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports